import React from 'react';
import { appdata } from '../../logic_tmp/appdata/AppData';
import i18next from 'i18next';

export const OrganizerInfo = () => {
    const company = appdata?.product?.partnerCompany || {};

    if (!company.name) return null;

    return (
        <div className="mt-4 p-3 border rounded bg-light">
            <h5 className="mb-3">{i18next.t("Organizer")}:</h5>
            <div className="organizer-info">
                <p className="mb-2">
                    <strong>{company.name}</strong>
                </p>
                <p className="mb-2">
                    {i18next.t("RegistrationNumber")}: {company.regCode}
                </p>
                <p className="mb-2">
                    {i18next.t("Address")}: {company.address}
                </p>
                {company.vatNumber && (
                    <p className="mb-2">
                        VAT: {company.vatNumber}
                    </p>
                )}
                {company.contacts && (
                    <div className="mt-3">
                        <p className="mb-2">
                            <strong>{i18next.t("Contacts")}:</strong>
                        </p>
                        {company.contacts.phone && (
                            <p className="mb-1">
                                {i18next.t("Phone")}: {company.contacts.phone}
                            </p>
                        )}
                        {company.contacts.email && (
                            <p className="mb-1">
                                Email: {company.contacts.email}
                            </p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}; 